import "moment-timezone";

import ApplicationRouter from "./router";
import { ConfirmProvider } from "material-ui-confirm";
import DateFnsUtils from "@date-io/date-fns";
import { Fade } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@material-ui/core/styles";
import { TransitionProps } from "@material-ui/core/transitions";
import ruLocale from "date-fns/locale/ru";
import { store } from "./store";
import { refreshTokenAction } from "./store/Auth/AuthAction";
import { canStartTokenRefresh } from "./api/jwt";
import theme from "./theme";

const rootElement = document.getElementById("root");

if (store.getState().auth.isAuthenticated && canStartTokenRefresh()) {
  store.dispatch(refreshTokenAction());
}

const FadeTransition = (props: TransitionProps) => <Fade {...props} />;

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        TransitionComponent={FadeTransition}
        maxSnack={5}
      >
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
          <ConfirmProvider
            defaultOptions={{
              confirmationText: "Да",
              cancellationText: "Нет",
              contentProps: {
                dividers: true,
              },
              confirmationButtonProps: {
                size: "small",
                variant: "contained",
                color: "primary",
              },
              cancellationButtonProps: {
                size: "small",
                variant: "outlined",
                color: "primary",
              },
            }}
          >
            <ApplicationRouter />
          </ConfirmProvider>
        </MuiPickersUtilsProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </Provider>,
  rootElement
);
